import {
  LOADING_UPDATECARDHOLDER_DETAILS,
  UPDATECARDHOLDER_DETAILS_INVALID_REQUEST,
  UPDATECARDHOLDER_DETAILS_NOTFOUND,
  UPDATECARDHOLDER_DETAILS_SUCCESS,
  UPDATECARDHOLDER_DETAILS_FAILED,
  RESET_UPDATECARDHOLDER_DETAILS
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATECARDHOLDER_DETAILS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: ""
      };
    case UPDATECARDHOLDER_DETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case UPDATECARDHOLDER_DETAILS_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case UPDATECARDHOLDER_DETAILS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case UPDATECARDHOLDER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_UPDATECARDHOLDER_DETAILS:
      return (state = initialState);

    default:
      return state;
  }
};
